<div class="multi-cta" *ngIf="data" [ngClass]="data?.style">
    <finder-component-header
        [data]="data"
    ></finder-component-header>
    <p class="intro" *ngIf="data.text" [innerHTML]="data.text | safeHtml" ></p>
    <div class="button" *ngIf="data.button">
        <h4 *ngIf="data.buttonHeader" class="header">{{data.buttonHeader}}</h4>
        <div class="items">
            <a finderAriaLabelHtml
                finderLinkId
                class="{{allowTracking}}"
                *ngFor="let button of data.button"
                [attr.target]="button.ctaButtonTarget || '_self'"
                [ngClass]="button.ctaButtonStyle"
                [innerHTML]="button.ctaButtonText | safeHtml"
                [attr.href]="button.ctaButtonUrl"
                type="button">
            </a>
        </div>
    </div>
    <div class="text" [ngClass]="{ 'single-text': singleText }" *ngIf="data.link">
        <h4 *ngIf="data.linkHeader" class="header">{{data.linkHeader}}</h4>
        <div class="items">
            <a finderAriaLabelHtml
                finderLinkId
                class="{{allowTracking}}"
                *ngFor="let link of data.link"
                [target]="link.ctaTextTarget || '_self'"
                [attr.href]="link.ctaTextUrl"
                type="button">
                <span [outerHTML]="link.ctaText | safeHtml"></span>
                <finder-font-icon size="s" htmlEntity="&#58124;" *ngIf="link?.ctaTextNextIcon !== 'false'"></finder-font-icon>
            </a>
        </div>
    </div>
</div>
